import React, { useState } from "react";
import OtpInput from "react-otp-input";
import "../blockpay.css";

export default function Pin(props) {
  return (
    <OtpInput
      className="otpInput"
      value={props.otp}
      onChange={props.setOtp}
      shouldAutoFocus={true}
      numInputs={6}
      isInputNum={true}
      renderSeparator={<span></span>}
      renderInput={(props) => <input {...props} />}
      // inputType="password"
      inputStyle={{
        border: "1px solid grey",
        borderRadius: "8px",
        width: "60px",
        height: "60px",
        fontSize: "14px",
        color: "#858da7",
        fontWeight: "400",
        caretColor: "blue",
      }}
      containerStyle={{
        justifyContent: "space-between",
        margin: "15px 0",
        // padding: "auto auto!important",
      }}
      focusStyle={{
        border: "2px solid black!important",
        outline: "none",
      }}
    />
  );
}
